module.exports = __webpack_public_path__ + "static/media/fillingBg4.bc3f9cf7.png";